import { fixString } from "./fixString";
import { useNavigate as useNavigateReact } from "./reactRouterDom";
import type { TNavigateFunction } from "./types";

export const useMontaNavigate = (): TNavigateFunction => {
  const navigate = useNavigateReact();

  const montaNavigate: TNavigateFunction = (...args) => {
    let [to, options] = args;

    if (typeof to === "number" || typeof to === "object" || !options)
      return navigate(to);

    const { baseUrl } = options;

    if (baseUrl) {
      to = fixString(to, baseUrl);
      window.location.href = to;
      return;
    }

    return navigate(to, options);
  };

  return montaNavigate;
};
